import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { Link as ScrollLink, animateScroll as scroll } from 'react-scroll';

import MenuButton from './MenuButton';
import GetBlidzButton from './GetBlidzButton';

import blidzLogo from '../assets/images/logo_background_dark_text.png';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

const Nav = styled.nav`
	display: flex;
	position: fixed;
	height: 80px;
	width: 100vw;
	padding: 20px 10vw;
	padding: 20px var(--side-margin);
	justify-content: space-between;
	z-index: 9;
	background-color:  white;
	transition: background-color 400ms ease-in-out;
	align-items: middle;

	#logo {
		max-height: 40px;

		img {
			object-position: left;
			object-fit: contain;
			height: 100%;
			max-height: 100%;
			max-width: 100%;
		}
	}

	> *:last-child {
		display: none;

		@media screen and (max-width: ${props => props.theme.mobileBreakPoint}) {
			display: block;
		}
	}
`;

const Links = styled.ul`
	display: flex;
	min-width: 40%;
	align-items: center;
	list-style-type: none;
	top: 0;
	left: 0;

	position: ${props => (props.isOpen ? 'absolute' : 'static')};
	width: ${props => (props.isOpen ? '100vw' : 'auto')};
	height: ${props => (props.isOpen ? '100vh' : 'auto')};
	flex-direction: ${props => (props.isOpen ? 'column' : 'row')};
	justify-content: ${props => (props.isOpen ? 'center' : 'space-between')};

	background-color: ${props => (props.isOpen ? 'white': 'transparent')};
	background-color: ${props =>
		props.isOpen ? 'var(white)' : 'transparent'};

	a {
		color: black;
		text-decoration: none;
		cursor: pointer;
	}

	& > li {
		margin: 10px;
	}

	> *:not(:last-child) {
		&::after {
			content: '';
			display: block;
			transform: scaleX(0);
			transform-origin: left;
			height: 2px;
			background: white;
			will-change: transform;
			transition: transform 0.3s;
			width: 100%;
		}

		&:hover::after {
			transform: scaleX(1);
		}
	}

	@media screen and (max-width: ${props => props.theme.mobileBreakPoint}) {
		min-width: unset;

		> * {
			display: ${props => (props.isOpen ? 'list-item' : 'none')};
			margin: 0 0 20px 0;

			animation: ${fadeIn} 400ms both;
		}
	}
`;

class NavBar extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			isTop: true,
			isOpen: false
		};

		this.scrollHandler = this.scrollHandler.bind(this);
	}

	scrollHandler = () => {
		//for the sake of compatibility
		const scrollTop =
			window.scrollY ||
			window.pageYOffset ||
			document.body.scrollTop +
				((document.documentElement && document.documentElement.scrollTop) || 0);

		scrollTop !== 0
			? this.state.isTop && this.setState({ isTop: false })
			: !this.state.isTop && this.setState({ isTop: true });
	};

	componentDidMount() {
		document.addEventListener('scroll', this.scrollHandler);
	}

	componentWillUnmount() {
		document.removeEventListener('scroll', this.scrollHandler);
	}

	scrollToTop = e => {
		this.props.match.isExact && e.preventDefault();
		scroll.scrollToTop();
	};

	render() {
		const { match } = this.props;
		const { isOpen, isTop } = this.state;

		const featureLink = match.isExact ? (
			<ScrollLink to="features" spy={true} smooth={true} duration={500}>
				Features
			</ScrollLink>
		) : (
			<Link to="/">Features</Link>
		);
		const pressLink = (
			<a
				href="https://drive.google.com/drive/u/2/folders/1dBGEheHuyCSbrWAXawWJncDDFw7_-igW"
				target="_blank"
				rel="noopener noreferrer"
			>
				Press
			</a>
		);
		const joinUsLink = <Link to="join-us">Join us</Link>;
		const blidzLink = <GetBlidzButton />;

		const links = [featureLink, pressLink, joinUsLink, blidzLink].map(
			(link, i) => (
				<li key={i} onClickCapture={() => this.setState({ isOpen: false })}>
					{link}
				</li>
			)
		);

		return (
			<Nav
				innerRef={navbar => (this.navbar = navbar)}
				style={
					isTop
						? {
							backgroundColor: 'transparent'
						  }
						: {}
				}
				isOpen={isOpen}
			>
				<Link to="/" id="logo" onClick={this.scrollToTop}>
					<img src={blidzLogo} alt="Blidz logo" />
				</Link>
				<Links isOpen={isOpen}>{links}</Links>
				<MenuButton
					handleClick={() => this.setState({ isOpen: !isOpen })}
					isOpen={isOpen}
				/>
			</Nav>
		);
	}
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar.js